import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    wsServers: [],
    esServer: null,
    allowedAudioCodecs: null,
    removedAudioCodecs: null,
    callIngestion: 'api',
    analyticsMinDuration: 40,
    analyticsEnabled: false,
    crmEnabled: false,
    crmTypes: [],
    storageEnabled: false,
    storageTypes: [],
    domainConfig: {},
};

export const configSlice = createSlice({
    name: "config",
    initialState,
    reducers: {
        // Everything the auth response carries. Login sends the lot, refresh
        // sends what it has; absent keys keep their current value.
        applyAuthConfig: (state, action) => {
            const next = { ...state };
            for (const [key, value] of Object.entries(action.payload || {})) {
                if (value !== undefined) next[key] = value;
            }
            if (!Array.isArray(next.wsServers)) next.wsServers = [];
            return next;
        },
        setAllowedAudioCodecs: (state, action) => {
            state.allowedAudioCodecs = action.payload;
        },
        setRemovedAudioCodecs: (state, action) => {
            state.removedAudioCodecs = action.payload;
        },
    },
});

export const {
    applyAuthConfig,
    setAllowedAudioCodecs,
    setRemovedAudioCodecs,
} = configSlice.actions;

// Selectors
export const selectConfig = (state) => state.config;
export const selectWsServers = (state) => state.config.wsServers;
export const selectEsServer = (state) => state.config.esServer;
export const selectCallIngestion = (state) => state.config.callIngestion;
export const selectAnalyticsMinDuration = (state) => state.config.analyticsMinDuration;
export const selectAnalyticsEnabled = (state) => state.config.analyticsEnabled;
export const selectCrmEnabled = (state) => state.config.crmEnabled;
export const selectCrmTypes = (state) => state.config.crmTypes;
export const selectStorageEnabled = (state) => state.config.storageEnabled;
export const selectStorageTypes = (state) => state.config.storageTypes;
export const selectDomainConfig = (state) => state.config.domainConfig;
export const selectAllowedAudioCodecs = (state) => state.config.allowedAudioCodecs;
export const selectRemovedAudioCodecs = (state) => state.config.removedAudioCodecs;


export default configSlice.reducer;
